var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('charts-app',{attrs:{"fetch":_vm.fetch,"defaultData":_vm.defaultData,"replaceFormItem":_vm.replaceFormItem}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }